module.exports = __webpack_public_path__ + "static/Mewshi@2x.1d70340c.png";